import ApiService from '../src/services/api.service'


const AwardService = {
	saveList: async function (data) {
		return ApiService.post('item/create/multiple-items', data)
	},
	// getList: async function () {
	// 	return ApiService.get(`/excel-parser/new-items`)
	// },
	// getById: async function (id) {
	// 	return ApiService.get(`/excel-parser/new-items/${id}`)
	// },
	delete: async function (id) {
		return ApiService.delete(`${main}/delete/${id}`)
	},
	update: async function (param) {
		let bodyFormData = new FormData();
		bodyFormData.append('upload', param.file)


		var requestData = {
			method: 'post',
			url: `/excel-parser/new-items`,
			data: bodyFormData,
			headers: {'Content-Type': 'multipart/form-data'}
		};
		try {
			return await ApiService.customRequest(requestData);

		} catch (error) {
			return error.response.data
		}
	},
	create: async function (form) {
		let bodyFormData = new FormData();
		bodyFormData.append('upload', form.file)

		// var data = {
		// 	departmentId: param.departmentId,
		// 	nameLt: param.nameLt,
		// 	nameRu: param.nameRu,
		// 	nameUz: param.nameUz,
		// }

		// var res = await ApiService.post(`${main}/create`, data)
		var requestData = {
			method: 'post',
			url: `/excel-parser/new-items`,
			data: bodyFormData,
			headers: {'Content-Type': 'multipart/form-data'}
		};
		try {
			return await ApiService.customRequest(requestData);

		} catch (error) {
			return error.response.data
		}
	},

}

export default AwardService;
